/* unplugin-vue-components disabled */import { render } from "./SeesawQuestionEditor.vue?vue&type=template&id=42ae9a72&scoped=true"
import script from "./SeesawQuestionEditor.vue?vue&type=script&lang=js"
export * from "./SeesawQuestionEditor.vue?vue&type=script&lang=js"

import "./SeesawQuestionEditor.vue?vue&type=style&index=0&id=42ae9a72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ae9a72"]])

export default __exports__